import React, {useContext, useRef, useState} from "react";
import PagedSearchTable, {PagedTableFunctions} from "../components/PagedSearchTable";
import AgronomistController from "../controllers/AgronomistController";
import FirestoreAgronomist from "../controllers/FirestoreAgronomist";
import {showSuccessOrFailed} from "../Snacks";
import AppContext from "../appContext";
import {EditRow, EditTable} from "../components/Fields";
import Dialog from "../components/Dialog";
import {useValidation} from "../validation";
import Originate from "../controllers/Originate";
import {wrapLoader} from "../wrapper";
import SelectNumberNullable from "../components/SelectNumberNullable";

const emptyFirestoreAgronomist: FirestoreAgronomist = {
    id: 0,
    name: '',
    archived: false,
    originate: Originate.International
}

const ManageAgronomists: React.FC = (props) => {
    const pagedTableRef = useRef<PagedTableFunctions<FirestoreAgronomist>>()
    const context = useContext(AppContext)
    const [assignAgronomist, setAssignAgronomist] = useState<FirestoreAgronomist | null>(null)
    const [agronomists, setAgronomists] = useState<FirestoreAgronomist[]>()
    const [newAgronomistId, setNewAgronomistId] = useState<number | null>(null)

    const validationDelete = useValidation({
        reassigned: () => newAgronomistId !== null
    })
    
    function deleteAgronomist(){
        if (!validationDelete.validate() || assignAgronomist == null || newAgronomistId == null) return;

        showSuccessOrFailed(context, AgronomistController.archive({id: assignAgronomist.id, assignId: newAgronomistId})).then(() => {
            cancelAgronomistAssign()
            pagedTableRef.current?.refresh();
        })
    }

    function cancelAgronomistAssign() {
        setAssignAgronomist(null)
        setNewAgronomistId(null)
    }

    function agronomistAssign(agronomist: FirestoreAgronomist) {
        wrapLoader(context, AgronomistController.index(), resp => {
            setAgronomists(resp)
            setAssignAgronomist(agronomist)
        })
    }

    return <div>
        <PagedSearchTable componentRef={pagedTableRef}
                          call={AgronomistController.paged}
                          columns={[
                              {
                                  header: 'Agronomist',
                                  key: 'agronomist',
                                  row: (row) => row.name
                              },
                              {
                                  header: <div className='text-right'>Actions</div>,
                                  key: 'actions',
                                  row: (row, index) => <div className='text-right'>
                                      <div className="bg-red-500 btn-sm"
                                           onClick={() => agronomistAssign(row)}>x
                                      </div>
                                  </div>
                              }
                          ]}/>
        
        <Dialog title={`Assign ${assignAgronomist?.name ? assignAgronomist.name : "this agronomist"} to New Agronomist`}
                show={assignAgronomist != null}
                setShow={cancelAgronomistAssign}
                body={<div>
                    <EditTable discard={() => cancelAgronomistAssign()}
                               save={() => deleteAgronomist()}
                               saveWord={'ReAssign'}>
                        {agronomists !== null && agronomists ? EditRow('Agronomist', <div className='text-right'>
                                <SelectNumberNullable options={agronomists.filter(a => a.id !== assignAgronomist?.id)}
                                                      textFunc={t => t.name ?? ""}
                                                      valueFunc={v => v.id}
                                                      value={newAgronomistId}
                                                      onChange={v => setNewAgronomistId(v)}/>
                            </div>,
                            validationDelete.rules.reassigned,
                            'Select a agronomist to reassign'
                        ) : null}
                    </EditTable>
                </div>}/>
    </div>
}

export default ManageAgronomists;